import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NumbersDirective } from './directives/numbers.directive';
import { MustMatchEmailDirective } from './directives/must-match-email.directive';
import { MustMatchPasswordDirective } from './directives/must-match-password.directive';
import { DeleteGeneralDialogComponent } from './dialogs/delete/delete-general-dialog.component';
import { GeneralDialogComponent } from './dialogs/general-dialog/general-dialog.component';
import { InfoDialogComponent } from './dialogs/info-dialog/info-dialog.component';
import { ViewFileDialogComponent } from './dialogs/view-file/view-file.component';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';
import { RegistryMedicalInformationsComponent } from './components/registry/registry-medical-informations/registry-medical-informations.component';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSelectModule } from '@angular/material/select';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MaterialFileInputModule } from 'ngx-material-file-input';
import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { FormsModule } from '@angular/forms';
import {NgbDropdownModule} from "@ng-bootstrap/ng-bootstrap";
import { GdprDialogComponent } from './dialogs/gdpr-dialog/gdpr-dialog.component';
import { NotifierDialogComponent } from './dialogs/notifier-dialog/notifier-dialog.component';
import { RegistryPatientMedicalRecordsComponent } from './components/registry/registry-patient-medical-records/registry-patient-medical-records.component';
import { RouterModule } from '@angular/router';
import { PasswordComplexityDirective } from './directives/password-complexity.directive';
import { AccessibilityComponent } from './components/accessibility/accessibility.component';
import { AccessibilityDialogComponent } from './dialogs/accessibility-dialog/accessibility-dialog.component';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { UsernameDirective } from './directives/username.directive';
import { AddPatientAccountComponent } from './dialogs/add-patient-account/add-patient-account.component';
import { InformationDialogComponent } from './dialogs/information-dialog/information-dialog.component';
import { MatDividerModule } from '@angular/material/divider';
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    NgxExtendedPdfViewerModule,
    MatButtonModule,
    MatDialogModule,
    MatIconModule,
    MatTooltipModule,
    MatTableModule,
    MatPaginatorModule,
    MatFormFieldModule,
    MatInputModule,
    MatSnackBarModule,
    MatSortModule,
    MatToolbarModule,
    MatSelectModule,
    MatCheckboxModule,
    MatSlideToggleModule,
    MatButtonToggleModule,
    MaterialFileInputModule,
    PerfectScrollbarModule,
    NgbDropdownModule,
    RouterModule,
    MatDividerModule
  ],
  declarations: [
    MustMatchEmailDirective,
    MustMatchPasswordDirective,
    PasswordComplexityDirective,
    UsernameDirective,
    NumbersDirective,
    DeleteGeneralDialogComponent,
    GeneralDialogComponent,
    InfoDialogComponent,
    ViewFileDialogComponent,
    RegistryMedicalInformationsComponent,
    RegistryPatientMedicalRecordsComponent,
    GdprDialogComponent,
    NotifierDialogComponent,
    AccessibilityComponent,
    AccessibilityDialogComponent,
    AddPatientAccountComponent,
    InformationDialogComponent,
  ],
  exports: [
    MustMatchEmailDirective,
    MustMatchPasswordDirective,
    PasswordComplexityDirective,
    NumbersDirective,
    UsernameDirective,
    DeleteGeneralDialogComponent,
    GeneralDialogComponent,
    InfoDialogComponent,
    ViewFileDialogComponent,
    RegistryMedicalInformationsComponent,
    RegistryPatientMedicalRecordsComponent,
    GdprDialogComponent,
    NotifierDialogComponent,
    AccessibilityComponent,
    AccessibilityDialogComponent,
    AddPatientAccountComponent,
    InformationDialogComponent,
  ]
})
export class SharedModule {}
